
import {useRequestHelper} from "@/helpers/request.helper";
import type {GrupoPermissaoVm, PermissaoSistemaVm} from "@/domain/type/grupoPermissao.type";
import type {AlterarGrupoPermissaoCommand, CadastrarGrupoPermissaoCommand} from "@/domain/commands/grupoPermissao.commands";

const {sendRequestPost} = useRequestHelper();

class GrupoPermissaoService {

    cadastrar(command: CadastrarGrupoPermissaoCommand){
        return sendRequestPost<number>("grupo-permissao/cadastrar",command);
    }

    alterar(command: AlterarGrupoPermissaoCommand){
        return sendRequestPost<number>("grupo-permissao/alterar",command);
    }


    listar(query: {cgpe:string,codigoGrupoPermissao:number}){
        return sendRequestPost<GrupoPermissaoVm[]>("grupo-permissao/listar",query);
    }

    listarPermissoes(){
        return sendRequestPost<PermissaoSistemaVm[]>("grupo-permissao/listar-permissoes",{})
    }
}

export default new GrupoPermissaoService();